
import React, { Component } from 'react'
import { lastStepActive, lastStepInactive, nextStep, finishTask ,AttachmentArrowRightNav,AttachmentArrowLeftNav,AttachmentArrowLeftDisabledNav} from '../../../Templates/icons'

export default class NavigationButtons extends Component {
    
    render() {
        
        const { flatSteps, currentStepIndex, moveStep, exitPreview, fromPreview } = this.props
        {typeof fromPreview == "undefined" ? fromPreview = false : console.log() }
        // id={fromPreview ? "wi-preview-nav-button-container-preview" : "wi-preview-nav-button-container"} className={fromPreview ? "flex-row" : "flex-column"}
        return <div id="wi-preview-nav">
            {/* {currentStepIndex ? lastStepActive(() => moveStep(currentStepIndex - 1)) : lastStepInactive}
            {currentStepIndex < flatSteps.length - 1 ? nextStep(() => moveStep(currentStepIndex + 1)) : null}
            {currentStepIndex === flatSteps.length - 1 ? finishTask(exitPreview) : null} */}

            {currentStepIndex ? AttachmentArrowLeftNav(() => moveStep(currentStepIndex - 1),true) : AttachmentArrowLeftDisabledNav(true)}
            {currentStepIndex < flatSteps.length - 1 ? AttachmentArrowRightNav(() => moveStep(currentStepIndex + 1),true) : null}
            {currentStepIndex === flatSteps.length - 1 ? finishTask(exitPreview) : null}
        </div>
    }
}
